import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import feemonkLogo from "../../assets/images/FeeMonk_HighRes_Logo.png"
import slider from "../../assets/images/slider.png"
import { useParams } from 'react-router-dom';
import Modal from "@mui/material/Modal";
import { Box, Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import axiosInstance from "../../helpers/axios";
import { useLocation,useNavigate } from 'react-router-dom';
// import { process.env.REACT_APP_DASHBOARD_URL } from "../../utils/key";
import OtpConsent from "./OtpConsent/OtpConsent";

function GettingStarted() {
  const navigate = useNavigate();
  const [openOtpConsent, setOpenOtpConsent] = useState(false);
  const user = useParams();
  const path = window?.location?.pathname;
  console.log("path-->", path);

  let rawPathSegment = path?.substring(1);
  console.log("rawPathSegment (raw)-->", rawPathSegment);

  let tokenData = null; // Stays null if decoding fails or is invalid

  // Declare these variables outside the try-catch block
  // so they are accessible in the catch block and later in the component.
  let decodedPathSegment = '';
  let actualBase64String = '';

  try {
    // 1. Decode URL-encoded characters (like %22, %2D, etc.)
    decodedPathSegment = rawPathSegment ? decodeURIComponent(rawPathSegment) : '';
    console.log("decodedPathSegment-->", decodedPathSegment);

    // 2. Use a regex to *extract* the valid Base64 portion from the decoded string.
    const base64Match = decodedPathSegment.match(/^([A-Za-z0-9\-_+/]*={0,2})/);

    if (base64Match && base64Match[1]) {
      actualBase64String = base64Match[1];
      console.log("extractedBase64String-->", actualBase64String);

      // If the extracted string is empty after all this, it's invalid.
      if (actualBase64String) { // Only proceed if actualBase64String is not empty
        // 3. Convert URL-safe base64 to standard base64 (if - or _ were present)
        const standardBase64 = actualBase64String
          .replace(/-/g, '+')
          .replace(/_/g, '/');

        // 4. Add padding if necessary (important for atob)
        const paddedBase64 = standardBase64 + '='.repeat((4 - standardBase64.length % 4) % 4);

        // 5. Decode the Base64 string
        const jsonString = atob(paddedBase64);
        console.log("Decoded JSON String-->", jsonString);

        // 6. Parse the JSON
        tokenData = JSON.parse(jsonString);
        console.log(tokenData, "user is");
      } else {
        console.error("Invalid Base64 string or empty path segment after extraction.");
        console.error("Original path segment:", rawPathSegment);
      }
    } else {
      console.error("No valid Base64 string found at the beginning of the path segment after decoding.");
      console.error("Decoded path segment value:", decodedPathSegment);
    }
  } catch (error) {
    console.error("Error decoding Base64 or parsing JSON:", error);
    // Log the relevant string that caused the error for debugging
    console.error("String attempted to decode:", actualBase64String || decodedPathSegment || rawPathSegment);
  }

  console.log(tokenData, "final tokenData"); // Line 77 (approx)

  // ALL REACT HOOKS MUST BE DECLARED AT THE TOP LEVEL OF THE COMPONENT.
  // Move the rest of your useState declarations here:
  const [opened, setOpened] = useState(false);
  const [link, setLink] = useState("");
  const [summaryDetails,setSummaryDetails] = useState(null)
  const [products,setProducts] = useState([])
  const [productId,setProductId] = useState(null)
  const [emi,setEmi] = useState(null)
  const [open, setOpen] = useState(false); // Line 84 (approx)

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpened = () => setOpened(true);
  const handleCloseConsent = () => setOpened(false);

  const handleSubmit = async () => {
    // Add a check here if tokenData is null
    if (!tokenData?.applicationId) {
      console.error("No valid tokenData available to submit consent.");
      alert("Application data not loaded. Please try again or check the URL.");
      return;
    }
    try {
      const authUrl = `/login/auth`;
      const memberPayload = {
        memberId: "5cf36857-5a37-4881-b740-1d33a8431cfc",
      };

      const authRes = await axiosInstance.post(authUrl, memberPayload);
      const authToken = authRes?.data?.data;

      if (!authToken) {
        throw new Error("Authorization token not received.");
      }

      const url = `admin/application/stage?applicationId=${tokenData?.applicationId}`;
      const res = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

       if(res?.data?.data?.status === "In Submission"){
        handleConsent();
      }else{
        navigate("/thank-you")
      }
    } catch (error) {
      console.log("handleSubmit error", error);
      alert(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to submit consent. Please try again."
      );
    }
  };

  const handleStartSession = () => {
    // Add a check here if tokenData is null
    if (!tokenData?.name || !tokenData?.phone) {
      console.error("User data not available for bureau session.");
      alert("User data not loaded. Cannot start bureau session.");
      return;
    }
    const randomGen =
      Date.now().toString(36) + Math.random().toString(36).substr(2);

    window
      .getBureauSession(
        "74265ef8ad1a440ab45999fc061e6205",
        randomGen,
        tokenData?.name,
        "",
        "",
        tokenData?.phone
      )
      .then((res) => {
        console.log(res);

        handleOpened();
        handleClose();
        setLink(res);
      });
  };

  const handleLoadSession = async () => {
    const result = await window.startBureauSession();
    if (result) {
      switch (result.status) {
        case "SUCCESS":
          // Add a check here if tokenData is null
          if (!tokenData?.userId || !tokenData?.applicationId) {
            console.error("User or application ID not available for summary/qec submission.");
            alert("Application data not loaded. Cannot submit consent.");
            return;
          }
          const getSummary = `/summary/user?id=${tokenData?.userId}&applicationId=${tokenData?.applicationId}`;

          axiosInstance.get(getSummary)
            .then((res) => {
              console.log("responsee", res?.data?.data.loanTenure);
              setSummaryDetails(res?.data?.data);
              const loanTenure = res?.data?.data.loanTenure;

              const authUrl = `/login/auth`;
              const memberId = {
                memberId: "5cf36857-5a37-4881-b740-1d33a8431cfc"
              };

              axiosInstance.post(authUrl, memberId)
                .then((authRes) => {
                  console.log("Auth Response:", authRes);
                  const authToken = authRes?.data?.data;

                  const data2 = {
                    userId: tokenData?.userId,
                    latitude: 0,
                    longitude: 0,
                    doneBy : "NxtWave CRM"
                  };

                  axiosInstance.post(`/end-user/submit/qec`, data2, {
                    headers: { Authorization: `Bearer ${authToken}` },
                  })
                  .then((res) =>{console.log(res);navigate("/thank-you")})
                  .catch((error) => {
                    alert("Error While Submitting Consent");
                    console.log("error", error)});
                })
                .catch((err) => console.log("Auth Error:", err));
            })
            .catch((err) => console.log("Summary Error:", err));
         console.log("success")

          break;

        case "EXIT":
          handleCloseConsent();
          break;

        case "ERROR":
          alert("Error Please Try Later");
          handleCloseConsent();
          break;

        default:
          alert("Contact our team for assistance");
          break;
      }
    }
  };

 const submitUserOtpConsent = async () => {
  // Add a check here if tokenData is null
  if (!tokenData?.userId || !tokenData?.applicationId) {
    console.error("User or application ID not available for OTP consent submission.");
    alert("Application data not loaded. Cannot submit OTP consent.");
    handleConsent(); // Close consent modal if data is missing
    return;
  }
  try {
    // Step 1: Fetch summary details
     const authUrl = `/login/auth`;
    const memberPayload = {
      memberId: "5cf36857-5a37-4881-b740-1d33a8431cfc",
    };

    const authRes = await axiosInstance.post(authUrl, memberPayload);
    const authToken = authRes?.data?.data;

    const summaryUrl = `/summary/user?id=${tokenData?.userId}&applicationId=${tokenData?.applicationId}`;
    const summaryRes = await axiosInstance.get(summaryUrl ,{
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    setSummaryDetails(summaryRes?.data?.data);

    // Step 2: Authenticate to get Bearer token
   

    if (!authToken) {
      throw new Error("Authorization token not received.");
    }

    // Step 3: Submit consent
    const consentPayload = {
      userId: tokenData?.userId,
      latitude: 0,
      longitude: 0,
      doneBy: "NxtWave CRM",
    };

    const consentRes = await axiosInstance.post(`/end-user/submit/qec`, consentPayload, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    navigate("/thank-you");

  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "An unexpected error occurred. Please try again.";
    alert(`Error: ${message}`);
    handleConsent()
    window.location.reload();
  }
};

  const handleConsent = () => {
    setOpenOtpConsent(!openOtpConsent);
  }

  return (
    <div className={styles.main}>
       <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={opened}
        keepMounted
        closeAfterTransition sx={{overflow:'auto'}}
      >
        <Box>
          <div
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "18rem",
              alignItems: "center",
              borderRadius: "8px",
              padding: "20px 20px",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={{
                fontWeight: "500",
                fontSize: "20px",
              }}
            >

            </Typography>
            <IconButton
              aria-label="remove"
              size="small"
              className="modal-close"
            >

            </IconButton>
          </div>

          <Box display="flex" justifyContent="center" alignItems="center">
            <iframe
              width="450"
              height="630"
              src={link}
              onLoad={handleLoadSession}
              title="bureau"
            ></iframe>
          </Box>
        </Box>
      </Modal>
      <img src={feemonkLogo} alt="" className={styles.image} />
      <p className={styles.text}>
      Simplified education fee payments & fiscal management
      </p>
       <OtpConsent openOtpConsent={openOtpConsent} submitUserOtpConsent={submitUserOtpConsent} handleConsent={handleConsent} mobile={ tokenData?.phone}/>
        <button className={styles.button} onClick={handleSubmit}>
          <img src={slider} alt="" />
          <span style={{color:'black'}}>SUBMIT CONSENT</span>
        </button>

    </div>
  );
}

export default GettingStarted;
